import { Checkbox } from "@mui/material";
import { FC, useEffect, useMemo, useState } from "react";
import { Collaborator, toggleCollaboratorCompanyBlockById } from "src/apis/company";
import { isUserAdministrator } from "src/utils/auth";

interface CompanyBlockCheckboxCellProps {
  collaborator: Collaborator;
}

const CompanyBlockCheckboxCell: FC<CompanyBlockCheckboxCellProps> = ({ collaborator }) => {
  const [checked, setChecked] = useState<boolean>(collaborator?.bloqueio_empresa ?? false);
  const [isLoading, setIsLoading] = useState(false);
  const isAdmin = useMemo(isUserAdministrator, []);

  useEffect(() => {
    setChecked(collaborator?.bloqueio_empresa ?? false);
  }, [collaborator?.bloqueio_empresa]);

  const handleToggle = async () => {
    if (!isAdmin) return;

    setIsLoading(true);
    try {
      await toggleCollaboratorCompanyBlockById(
        collaborator?.id_empresa,
        collaborator?.id_colaborador,
        !checked,
      );
      setChecked((prev) => !prev);
    } catch (err: any) {
      console.error(err);
      alert(err?.message || "Erro ao atualizar bloqueio da empresa.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Checkbox
      disabled={!isAdmin || isLoading}
      checked={checked}
      title={
        isAdmin
          ? checked
            ? "Desmarcar bloqueio da empresa"
            : "Marcar empresa como bloqueada"
          : checked
            ? "Empresa com pendências"
            : "Empresa ativa"
      }
      onClick={() => {
        if (!isAdmin) return;

        const action = checked ? "desmarcar o bloqueio da" : "marcar como bloqueada a";
        if (!window.confirm(`Deseja ${action} empresa do colaborador ${collaborator?.nome}?`)) {
          return;
        }

        handleToggle();
      }}
    />
  );
};

export default CompanyBlockCheckboxCell;
